/**
 * Single source of truth for all feature flags. Keys are the property names returned by
 * `useFeatureFlags`; values are the Unleash flag name strings.
 *
 * To add a new flag: add one entry here. The type and hook derive from this automatically.
 */
export const FeatureFlags = {
    // Do not remove. This flag is meant to be a permanent
    // feature flag demonstration and testing utility.
    isFeatureFlagDemoFeatureEnabled: 'feature-flag-demo',
    // -
    isNqrCvtDiagnosticsFeatureEnabled: 'nqr-cvt-diagnostics',
    // -
    isOtpwFlowFeatureEnabled: 'otpw-flow',
    // -
    isServiceDiagnosticsSearchFeatureEnabled: 'service-diagnostics-search',
    // -
    isSsm5DiagnosticsFeatureEnabled: 'ssm5-diagnostics',
    // -
    isQuickReferencesFeatureEnabled: 'quick-references',
} as const;
